import { Component, OnInit } from '@angular/core';
import * as L from 'leaflet';
import 'leaflet-defaulticon-compatibility';
import { environment } from 'src/environments/environment';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';

// provider of the map geosearch (OpenStreetMap)
const provider = new OpenStreetMapProvider({
  params: {
    viewbox: '8.20743,47.54461,8.24820,47.53102',
    bounded: 1,
    countrycodes: 'CH'
  }
});



// settings of the map geosearch
const searchControl = GeoSearchControl({
  provider,
  showMarker: true,
  autoClose: true,
  keepResult: true,
  style: 'bar',
  updateMap: true,
  searchLabel: 'Enter address',
  retainZoomLevel: false,
  // Filter results manually after search
  filterResults: (results) =>
    results.filter(r => r.raw?.address?.country_code === 'ch')
});

@Component({
  selector: 'app-map',
  templateUrl: './map.page.html',
  styleUrls: ['./map.page.scss'],
})

export class MapPage implements OnInit {

  // init variables
  public map: any;
  public marker: any;
  public latlng: any;
  public assets = environment.assets;
  public mapInitialized: boolean;

  // icon for the geolocation
  public locationIcon = L.icon({
    iconUrl: environment.assets + '/circle.png',
    iconSize: [22, 22], // size of the icon
  });

  constructor() { }

  // Action OnInit
  ngOnInit() {
    this.initializeMap();
    setTimeout(this.map.invalidateSize.bind(this.map), 100);
  }

  // init map for user
  public initializeMap() {
    this.map = L.map('map', { attributionControl: false }).setView([47.537598, 8.225227], 16);
    L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
      zoom: 18,
      maxZoom: 19
    }).addTo(this.map);
    this.map.addControl(searchControl);
    this.map.invalidateSize();
    this.mapInitialized = true;
  }

  // find geolocation of the user
  public findUserlocation() {
    if (this.marker !== undefined) {
      this.map.removeLayer(this.marker);
    }
    //get location of user
    navigator.geolocation.getCurrentPosition((position) => {
      this.latlng = new L.LatLng(position.coords.latitude, position.coords.longitude);
      this.marker = L.marker(this.latlng, { icon: this.locationIcon }).addTo(this.map);
      this.marker.bindPopup('This is your Location').openPopup();
      this.map.setView(this.latlng, 16);
      this.map.invalidateSize();
    });
  }

  // centers the map at the paul scherrer institute
  public goBackToPsi() {
    this.map.setView([47.537598, 8.225227], 16);
    this.map.invalidateSize();
  }
}
